const condoSec3_Object = (payload) => {
  return {
    type: "condoSec3",
    payload,
  };
};

export default condoSec3_Object;
